export default __webpack_public_path__ + "static/media/milestone 600.ead69e6f.svg";